import React, { useEffect } from 'react';
import '../styles/indian-card-betting.css';

const IndianCardGamesBettingPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const message = "Need Cricket ID";
  const encodedMessage = encodeURIComponent(message);
  const ContactLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  const whatsappLink = `https://wa.me/919024000691?text=${encodedMessage}`;
  return (
    <div className="indian-card-betting-page">
      <section className="indian-card-betting-intro">
        <div className="indian-card-betting-intro-content">
          <h1><span>Reddy Anna Indian Card Games:</span> Experience the Perfect Fusion of Tradition and Modern Gaming</h1>
          <p>
            Welcome to Reddy Anna Indian Card Games, where timeless traditions meet modern entertainment. Our platform invites you to dive into a world filled with classic Indian card games, enriched with exciting new features. Whether you're seeking nostalgia or fresh challenges, we offer a rich array of games that combine culture, strategy, and excitement, offering something for everyone.
          </p>
          <div className="indian-card-betting-cta-buttons">
            <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Open Your Demo Account
            </a>
            <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
              Contact Us Now
            </a>
          </div>
        </div>

        <div className="indian-card-betting-intro-image">
          <img src="/indian-card-games.webp" alt="Indian Card Games Betting" className="tennis-image" />
        </div>
      </section>

      <section className="indian-card-betting-features">
        <h2><span>Reddy Anna</span>: A Rich Collection of <span>Classic Indian Card Games</span></h2>
        <p>
          At Reddy Anna, we bring you a wide variety of classic Indian card games, each offering a unique experience. Whether you're a strategic mastermind in Teen Patti, a thrill-seeker in 7up 7down, a fast player in 32cards casino, or a fan of Hi Low and Roulette, we have it all. Explore games like Andhar Bahar, Poker, Bollywood Casino, Queen Race, Matka, Casino Meter, and 20-20 Poker for an exciting, all-encompassing experience. The adventure is limitless!
        </p>
        <ul>
          <li>
            <strong>Live Gaming Adventure: </strong> Reddy Anna offers more than just card games—it delivers an immersive live gaming experience. Play real-time games with others, engaging in thrilling moments with players from all over.
          </li>
          <li>
            <strong>Intuitive Design: </strong> Navigating through Reddy Anna is effortless. Our platform is designed for both experienced players and beginners, allowing you to easily explore new games, understand the rules, and jump into action without any hassle.
          </li>
        </ul>
        <div className="indian-card-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>

      <section className="indian-card-betting-getting-started">
        <h2><span>Reddy Anna</span>: Secure and Transparent Transactions</h2>
        <p>
          We take your security seriously. Reddy Anna implements state-of-the-art encryption methods to protect your financial transactions and sensitive information.
        </p>
        <p>
          We encourage responsible gaming. You can set personal limits and manage your gaming budget to ensure that your experience remains enjoyable and balanced.
        </p>
      </section>

      <section className="indian-card-betting-join">
        <h2>Join <span>Reddy Anna</span> Today!</h2>
        <p>
          Become part of Reddy Anna Indian Card Games and enjoy a thrilling gaming experience. With competitive odds, an easy-to-navigate platform, and dedicated customer support, we're here to provide you with an unforgettable adventure.
        </p>
        <div className="tennis-betting-cta-buttons">
          <a href={whatsappLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Open Your Demo Account
          </a>
          <a href={ContactLink} className="contactus-button" target="_blank" rel="noopener noreferrer">
            Contact Us Now
          </a>
        </div>
      </section>
    </div>

  );
};

export default IndianCardGamesBettingPage;
